var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarIcone)?_c('span',{staticClass:"text-success ml-1"},[_c('i',{staticClass:"fa fa-check-circle fa-lg",attrs:{"title":"Processo Recebido/Quitado"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }